<template>
  <!-- 审批节点设置 -->
  <transition name="slide-fade">
    <div class="cmp-approve-node-panel" v-if="showPanel">
      <h1>
        {{ pageType === 'approve' ? '审批节点设置' : '抄送人设置' }}
        <i class="el-icon-close g-pointer fr" @click="handleClose"></i>
      </h1>
      <p class="title mb-20">
        {{ pageType === 'approve' ? '审批人' : '抄送人' }}
      </p>
      <div class="approve-list-person">
        <div v-for="(item, index) in chooseList" :key="index">
          <div class="person-box mr-30 mb-20">
            <img class="g-pic" :src="item.userImage || ''" alt :onerror="defaultHeadImg" />
            <span class="m-des">{{ item.name }}</span>

            <i class="el-icon-close" @click="dele(item, index)"></i>
          </div>
        </div>

        <!-- 负责人 -->
        <el-popover class="pop-wrap" placement="bottom" trigger="click" v-model="showPopover">
          <el-tabs class="tabs-box" v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="姓名" name="first">
              <!-- 搜索负责人列表 悬浮面板 -->
              <!-- 抄送人 -->
              <cmp-leader-list v-if="pageType === 'copy'" ref="cmpLeaderList" :businessType="`copy`"
                :callFun="handleChooseAdd" :isSinglePro="false" @getApproveEvent="getApproveEvent"></cmp-leader-list>

              <!-- 审批人 -->
              <cmp-leader-list v-if="pageType === 'approve'" ref="cmpLeaderList" :businessType="`approve`"
                :callFun="handleChooseAdd" @getApproveEvent="getApproveEvent"></cmp-leader-list>
            </el-tab-pane>
            <el-tab-pane label="汇报人" name="second">
              <ul class="list-person">
                <li v-for="item in leaderList" :key="item.level">
                  <span>{{ item.name }}</span>
                  <i class="el-icon el-icon-check mr-20" v-if="item.status === '1'"></i>
                  <el-button class="el-primary-border mini" size="mini" v-if="item.status !== '1'"
                    @click="chooseLeader(item)">添加</el-button>
                </li>
              </ul>
            </el-tab-pane>
            <el-tab-pane label="部门角色" name="third">
              <el-form class ref="form" :model="form" :rules="rules">
                <el-row :gutter="20">
                  <el-col :span="24">
                    <el-form-item label="所属部门 :" prop="deptid" label-width="90px">
                      <el-select v-model="form.deptid" placeholder="请选择" @change="chooseDept($event)">
                        <el-option v-for="item in deptlist" :key="item.id" :label="item.name"
                          :value="item.id"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="部门角色 :" prop="roleid" label-width="90px">
                      <el-select v-model="form.roleid" placeholder="请选择" @change="chooseDept($event, 'role')">
                        <el-option v-for="item in deptrolelist" :key="item.id" :label="item.name"
                          :value="item.id"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
              <div>
                <el-button type="primary" @click="saveDept('form')">保存</el-button>
              </div>
            </el-tab-pane>
          </el-tabs>

          <span class="operate g-pointer" slot="reference" @click="handleClickAdd">
            <svg-icon icon-class="add-dash" style="font-size: 40px;"></svg-icon>
          </span>
        </el-popover>
      </div>

      <!-- 抄送人 -->
      <div class="copy-other" v-if="pageType === 'copy'">
        <div class="permit">
          <p class="title mt-30 mb-20">权限修改</p>
          <el-checkbox v-model="form.permission">发起审批时，员工不可修改抄送人</el-checkbox>
        </div>

        <div class="notice">
          <p class="title mt-30 mb-10">抄送通知</p>
          <el-radio-group v-model="form.notice">
            <el-radio :label="0">发起审批时抄送</el-radio>
            <el-radio :label="1">审批通过后抄送</el-radio>
          </el-radio-group>
        </div>
      </div>

      <div class="footer" @click="handleSure">确定</div>
    </div>
  </transition>
</template>

<script>
import cmpLeaderList from '@cmp/leader-list'
export default {
  components: { cmpLeaderList },
  data() {
    return {
      loadingSave: false,
      defaultHeadImg: this.$store.state.app.defaultHeadImg,
      showPanel: false,
      showPopover: false, // 选择人列表面板
      pageType: '', // approve:审批  copy:抄送
      activeName: 'second',
      leaderLevel: '', // 汇报人级别
      chooseList: [],
      form: {
        type: 'deptrole',
        deptid: '', // 部门id
        roleid: '', // 角色id
        name: '', // 部门名+角色名
        roleName: '', // 角色名
        deptName: '', // 部门名

        permission: false,
        notice: '0'
      },
      approveIndex: 0, // 审批的index
      rules: {
        deptid: [{ required: true, message: '必填', trigger: 'blur' }],
        roleid: [{ required: true, message: '必填', trigger: 'blur' }]
      },
      leaderList: [
        { name: '直接汇报人', level: '1', status: '0' },
        { name: '第二级汇报人', level: '2', status: '0' },
        { name: '第三级汇报人', level: '3', status: '0' }
      ],
      deptlist: [],
      deptrolelist: []
    }
  },
  methods: {
    init(type, data, index) {
      this.pageType = type // approve:审批  copy:抄送
      this.showPanel = true
      this.approveIndex = index // 审批的index

      if (this.pageType === 'copy') {
        this.chooseList = data.copyto.options

        data.copyto.options.forEach(item => {
          if (item.type === 'deptrole') {
            this.form = {
              type: 'deptrole',
              deptid: item.deptid, // 部门id
              roleid: item.roleid, // 角色id
              name: item.name // 角色名

              // permission: data.copyto.permission,
              // notice: data.copyto.notice
            }
          }
        })
        this.$set(this.form, 'permission', data.copyto.permission)
        this.$set(this.form, 'notice', Number(data.copyto.notice))
      } else if (this.pageType === 'approve') {
        this.chooseList = []
        if (data.type === 'deptrole') {
          this.form = {
            type: 'deptrole',
            deptid: data.deptid, // 部门id
            roleid: data.roleid, // 角色id
            name: data.name // 角色名
            // permission: data.permission,
            // notice: data.notice
          }
        } else if (!data.type) {
          this.form = {
            type: '',
            deptid: '', // 部门id
            roleid: '', // 角色id
            name: '' // 角色名
          }
        }
        this.chooseList.push(data)
      }
    },
    handleClickAdd() {
      this.activeName = 'first'
      this.$refs.cmpLeaderList.showList(this.chooseList)
      this.leaderList.forEach(it => {
        it.status = '0'
      })
    },
    handleClick() {
      if (this.activeName === 'second') {
        this.chooseList.forEach(item => {
          this.leaderList.forEach(it => {
            if (item.type === 'leader' && item.level === it.level) {
              it.status = '1'
            }
          })
        })
      }
    },
    // 选择抄送人、审批人
    handleChooseAdd(item) {
      item.type = 'user'
      if (this.pageType === 'approve') {
        this.chooseList = []
      }
      this.chooseList.push(item)
      this.showPopover = false
    },
    // 选择汇报人
    chooseLeader(item) {
      item.type = 'leader'
      item.status = '1'
      if (this.pageType === 'approve') {
        this.chooseList = []
      }
      this.chooseList.push(item)
      this.leaderLevel = item.id
      this.showPopover = false
    },
    // 选择部门、角色
    chooseDept(val, type) {
      if (type) {
        // 角色
        this.form.roleid = val
        let obj = this.deptrolelist.find(item => {
          return item.id === val
        })
        this.roleName = obj.name
      } else {
        // 部门
        this.form.deptid = val
        let obj = this.deptlist.find(item => {
          return item.id === val
        })
        this.deptName = obj.name
      }
      this.form.name = this.deptName + this.roleName
    },
    saveDept(form) {
      this.$refs[form].validate(valid => {
        if (valid) {
          this.form.type = 'deptrole'
          let objDept = ''
          if (this.pageType === 'approve') {
            this.chooseList = []
            objDept = false
          } else {
            objDept = this.chooseList.find(item => {
              if (item.type === 'deptrole') {
                item.name = this.form.name
                item.deptid = this.form.deptid
                item.roleid = this.form.roleid
                item.notice = this.form.notice
                item.permission = this.form.permission
                // item = this.form
              }
              return item.type === 'deptrole'
            })
          }
          if (!objDept) {
            this.chooseList.push(this.form)
          }
          this.showPopover = false
        }
      })
    },
    // 删除附件
    dele(item, index) {
      this.chooseList.splice(index, 1)
    },
    // 获取部门角色信息
    getApproveEvent(data) {
      this.deptlist = data.deptlist
      this.deptrolelist = data.deptrolelist
    },
    // 取消
    handleClose() {
      this.showPanel = false
      // this.$common.confirm(
      //   {
      //     title: '取消设置',
      //     content: '确认取消设置吗？'
      //   },
      //   () => {
      //     this.showPanel = false
      //   }
      // )
    },
    // 确认
    handleSure() {
      this.$emit(
        'getPanelData',
        {
          copyto: {
            permission: this.form.permission,
            notice: this.form.notice,
            options: [...this.chooseList]
          },
          approveObj: {
            index: this.approveIndex,
            item: this.chooseList[0]
          }
        },
        this.pageType
      )
      this.showPanel = false
    },
    close() {
      this.showPanel = false
    }
  }
}
</script>

<style lang="scss" scoped>
.cmp-approve-node-panel {
  position: fixed;
  padding: 30px;
  right: 0;
  top: 0;
  bottom: 0;
  width: 570px;
  box-sizing: border-box;
  background: #fff;
  box-shadow: 0px 1px 10px 0px rgba(150, 153, 162, 0.5);
  z-index: 3;

  .approve-list-person {
    display: flex;
    flex-wrap: wrap;

    .person-box {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;

      .g-pic {
        margin-bottom: 5px;
      }

      .el-icon-close {
        display: none;
        position: absolute;
        right: -7px;
        top: -7px;
        color: #fff;
        background-color: $color6;
        padding: 2px;
        border-radius: 100%;
        cursor: pointer;
        font-size: 12px;
      }

      &:hover .el-icon-close {
        display: block;
      }
    }
  }

  .copy-other {
    .el-radio-group {
      .el-radio {
        display: block;
        line-height: 40px;
        font-size: 14px;
      }
    }

    .notice {
      padding-top: 20px;
    }
  }

  .footer {
    width: 100%;
    position: absolute;
    left: 0;
    bottom: 0;
    line-height: 60px;
    text-align: center;
    color: #fff;
    font-size: 14px;
    cursor: pointer;
    background: rgba(5, 144, 255, 1);
    box-shadow: 0px 1px 10px 0px rgba(238, 239, 245, 1);
  }
}

.el-tabs.tabs-box {
  width: 400px;
  padding: 30px;
  padding-top: 0;
  box-sizing: border-box;
  box-shadow: 0px 1px 10px 0px rgba(150, 153, 162, 0.5);
  border-radius: 0px 0px 4px 4px;

  .list-person {
    li {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
      line-height: 40px;
      cursor: pointer;

      .el-icon-check {
        color: $primary;
      }

      &:hover {
        background: $color4;
      }
    }
  }

  /deep/ .cmp-leader-list {
    .m-search-wrap {
      width: 100% !important;
      box-shadow: none;

      .input-box {
        padding: 0;
      }
    }
  }

  /deep/ .el-tabs__nav {
    width: 100%;
    padding: 10px 0;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;

    .el-tabs__item {
      font-size: 16px;

      &.is-active {
        font-weight: bold;
      }
    }
  }

  /deep/ .el-tabs__active-bar {
    background: transparent;
  }

  /deep/ .el-tabs__nav-wrap::after {
    height: 1px;
    background-color: $border;
  }
}

/* 可以设置不同的进入和离开动画 */
/* 设置持续时间和动画函数 */
.slide-fade-enter-active {
  transition: all 0.7s;
  // transition: all 1s ease;
}

.slide-fade-leave-active {
  transition: all 0.5s;
  // transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-fade-enter,
.slide-fade-leave-to

/* .slide-fade-leave-active for below version 2.1.8 */
  {
  transform: translateX(570px);
  opacity: 0;
}
</style>
